import { render, staticRenderFns } from "./UserSexualPreferences.vue?vue&type=template&id=483a8104"
import script from "./UserSexualPreferences.vue?vue&type=script&lang=js"
export * from "./UserSexualPreferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports